import type { Plugin } from 'vue';
import { v4 as uuid } from 'uuid';

export interface EventBusInterface {
    subscriptions: Record<string, Record<string, <T>(params: T) => void>>;
    dispatch: <Params>(subscription: string, params: Params) => void;
    subscribe: <Params>(subscription: string, subscriber: (params: Params) => void) => string;
    unsubscribe: (subscription: string, subscriberId: string) => void;
    getSubscriptions: () => string[];
}

export default {
    install: (app) => {
        const eventbus: EventBusInterface = {
            subscriptions: {},
            dispatch: <Params>(subscription: string, params: Params) => {
                if (!eventbus.subscriptions[subscription]) {
                    return;
                }

                Object.keys(eventbus.subscriptions[subscription]).forEach((eventId) => {
                    eventbus.subscriptions[subscription][eventId]<Params>(params);
                });
            },
            subscribe: <Params>(subscription: string, subscriber: (params: Params) => void) => {
                const subscriberId = uuid();

                if (!(subscription in eventbus.subscriptions)) {
                    eventbus.subscriptions[subscription] = {};
                }

                Object.assign(eventbus.subscriptions[subscription], {
                    [subscriberId]: subscriber,
                });

                return subscriberId;
            },
            unsubscribe: (subscription: string, subscriberId: string) => {
                if (!eventbus.subscriptions[subscription]) {
                    // eslint-disable-next-line no-console
                    console.warn(`You cant unsubscribe if there are no subscriptions for: ${subscription}`);
                    return;
                }

                if (!eventbus.subscriptions[subscription][subscriberId]) {
                    // eslint-disable-next-line no-console
                    console.warn(`You cannot unsubscribe a subscriber (${subscriberId}) that is not subscribed to: ${subscription}`);
                    return;
                }

                delete eventbus.subscriptions[subscription][subscriberId];
            },
            getSubscriptions: () => Object.keys(eventbus.subscriptions),
        };

        app.provide('eventbus', eventbus);
        // eslint-disable-next-line no-param-reassign
        app.config.globalProperties.$eventBus = eventbus;
    },
} as unknown as Plugin;
